import { createSlice } from "@reduxjs/toolkit";

// Holds only in-memory UI state for the In-App Review Flow.
// All persistent state (already-reviewed flag, monthly count, last-shown timestamp,
// normalization-shown flag, session lock) lives in browser storage and is
// read/written through src/utils/reviewStorageUtils.js — never via this slice.

const reviewSlice = createSlice({
  name: "review",
  initialState: {
    promptVisible: false,
    currentTrigger: null, // value from REVIEW_TRIGGERS, or null when not visible
    normalizationVisible: false,
    exportSuccessWithReviewVisible: false,
  },
  reducers: {
    showPrompt(state, action) {
      state.promptVisible = true;
      state.currentTrigger = action.payload;
    },
    hidePrompt(state) {
      state.promptVisible = false;
      state.currentTrigger = null;
    },
    showNormalization(state) {
      state.normalizationVisible = true;
    },
    hideNormalization(state) {
      state.normalizationVisible = false;
    },
    showExportSuccessWithReview(state) {
      state.exportSuccessWithReviewVisible = true;
    },
    hideExportSuccessWithReview(state) {
      state.exportSuccessWithReviewVisible = false;
    },
  },
});

export const reviewActions = reviewSlice.actions;

export default reviewSlice;
